import * as Yup from 'yup';
import { LangTypes } from '../../../assets/lang/Types/langTypes';

export const editProfileValidationSchema = (translations: LangTypes) => Yup.object().shape({
  firstName: Yup
    .string()
    .max(25, translations.nameValidation),
  lastName: Yup
    .string()
    .max(25, translations.nameValidation),
  email: Yup.string(),
  phone: Yup
    .string().nullable(),
  cell: Yup
    .string().nullable(),
  address: Yup
    .string().nullable(),
  code: Yup
    .string().nullable(),
  title: Yup
    .string(),
  initials: Yup
    .string().nullable(),
});
